/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, Theme, useTheme } from 'bold-ui'

import { AtividadeColetivaGrupoCabecalho } from './model-atividadeColetivaGrupoSelectField'

interface AtividadeColetivaGrupoSelectFieldCabecalhoProps {
  tipoCabecalho: AtividadeColetivaGrupoCabecalho
}

export function AtividadeColetivaGrupoSelectFieldCabecalho(
  props: Readonly<AtividadeColetivaGrupoSelectFieldCabecalhoProps>
) {
  const { tipoCabecalho } = props
  const theme = useTheme()
  const localStyles = createStyles(theme)

  let descricaoGrupo = ''

  if (tipoCabecalho === AtividadeColetivaGrupoCabecalho.MEUS_GRUPOS) {
    descricaoGrupo = 'Meus grupos'
  } else if (tipoCabecalho === AtividadeColetivaGrupoCabecalho.OUTROS_GRUPOS) {
    descricaoGrupo = 'Outras equipes e unidades'
  } else {
    return null
  }

  return (
    <div css={localStyles.header}>
      <Heading level={4} color='primary'>
        {descricaoGrupo}
      </Heading>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  header: css`
    background-color: ${theme.pallete.primary.c90};
    padding: 0.3rem 0.5rem;
  `,
})
